import { ErrorIcon, InProgressIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Tooltip } from '@components/tooltip';
import { useOrganizationContext } from '@navigation/OrganizationContext';

interface DatasetsDetailsMicroserviceStatusProps {
  status: string;
  workspaceId: string;
  microServiceName: string;
  datasetId: string;
  microServiceId?: string;
}

export const DatasetsDetailsMicroserviceStatus = ({
  status,
  workspaceId,
  datasetId,
  microServiceId,
  microServiceName,
}: DatasetsDetailsMicroserviceStatusProps) => {
  const { organizationId } = useOrganizationContext();

  const lowerStatus = (status || '').toLocaleLowerCase();

  const url =
    microServiceName === 'models' ||
    microServiceName === 'inferences' ||
    microServiceName === 'umaps' ||
    microServiceName === 'analytics'
      ? `/${organizationId}/workspaces/${workspaceId}/experiments/${microServiceName}/${microServiceId}/logs`
      : `/${organizationId}/workspaces/${workspaceId}/datasets/${datasetId}/${microServiceName}/${microServiceId}/logs`;

  if (lowerStatus === 'failed' || lowerStatus === 'cancelled') {
    return (
      <Tooltip title="View logs" variant="secondary" disableInteractive>
        <IconButton
          Icon={ErrorIcon}
          variant="error"
          size={16}
          onClick={(e) => {
            e.preventDefault();
            if (microServiceId && url) {
              window.open(url, '_blank');
            }
          }}
          style={{ cursor: 'pointer' }}
        />
      </Tooltip>
    );
  }
  if (
    lowerStatus !== 'success' &&
    lowerStatus !== 'completed' &&
    lowerStatus !== 'complete' &&
    lowerStatus !== 'failed' &&
    lowerStatus !== 'cancelled'
  ) {
    return <InProgressIcon size={16} style={{ marginLeft: '6px' }} />;
  }
  return <div />;
};
